<template>
  <WsMain>
    <WsCRUD
      :modelName="modelName"
      :label="label"
      :fields="fields"
      :liveSearching="true"
      :sortBy="sortBy"
      :showFields="showFields"
      :pageMode="true"
      :filterSelects="filterSelects"
      :filterProps="filterProps"
      @filter-select="$_onFilterSelect($event)"
    ></WsCRUD>
  </WsMain>
</template>

<script>
import model from "@/models/system_class";
export default {
  data: () => ({
    modelName: model.modelName,
    label: model.label,
    fields: model.fields,
    showFields: [
      "sequence",
      "icon",
      "area",
      "name",
      "updated_at",
      "updated_admin",
    ],
    liveSearching: true,
    sortBy: "sequence",
    filterSelects: [
      {
        type: "belongsTo",
        label: "",
        textKey: "name",
        modelName: "area",
        placeholder: "請選擇地區",
      },
    ],
    filterProps: {},
  }),
  methods: {
    $_onFilterSelect($event) {
      this.filterProps = {
        ...$event,
      };
    },
  }
};
</script>

<style>
</style>